import { render, staticRenderFns } from "./chat_input.vue?vue&type=template&id=f8e92500&scoped=true"
import script from "./chat_input.vue?vue&type=script&lang=js"
export * from "./chat_input.vue?vue&type=script&lang=js"
import style0 from "./chat_input.vue?vue&type=style&index=0&id=f8e92500&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f8e92500",
  null
  
)

export default component.exports